export default __webpack_public_path__ + "static/media/hht2_ep11_speaking_01.9e5e9c04.png";